import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Show } from "shared/components";

export const OtherLeadsRecordedNote = ({
  leadIds,
  className
}: {
  leadIds?: number[];
  className?: string;
}) => {
  if (!leadIds?.length) return null;

  return (
    <p className={className}>
      Also recorded on{" "}
      {leadIds.length === 1 ? "1 other lead" : `${leadIds.length} other leads`}{" "}
      with this email address:{" "}
      {leadIds.map((leadId, index) => (
        <Fragment key={leadId}>
          <Show if={index > 0}>, </Show>
          <Link
            to={`/leads/${leadId}`}
            className="font-medium text-primary-500 hover:underline"
          >
            Lead #{leadId}
          </Link>
        </Fragment>
      ))}
    </p>
  );
};
